import React from 'react';

import {
  Controller,
  useForm
} from 'react-hook-form';
import {
  Button,
  MenuItem,
  Select,
  Stack,
  Typography
} from '@mui/material';
import {
  errorUtil,
  fields,
  Form,
  formUtil
} from 'iron-forge-react-modules';

import { BaseWidget } from 'modules';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [
    savePrintRequestLabelType,
    savePrintRequestLabelTypeTuple
  ] = dataService.useSavePrintRequestLabelType(props.storeId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      returnLabelType: 'rma-tmo',
      printRequestFunctionInternalId: '',
      printRequestLabelInternalId: '',
      printRequestPrinterInternalId: ''
    }
  });

  formUtil.useSetFormFields(queryTuple, form.setValue, [
    'returnLabelType',
    'printRequestFunctionInternalId',
    'printRequestLabelInternalId',
    'printRequestPrinterInternalId'
  ]);

  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      await errorUtil.errorWrap(async () => {
        await savePrintRequestLabelType(formState);
      });
    },
    [savePrintRequestLabelType]
  );

  const loading = queryTuple.loading || savePrintRequestLabelTypeTuple.loading;

  const fieldProps = {
    formControl: form.control,
    isRequired: true,
    isDisabled: loading,
    extraValidationRules: { pattern: /\d+/ }
  };

  return (
    <Form.FC
      disableDefaultOverflow
      onSubmit={form.handleSubmit(processSubmit)}>
      <BaseWidget.FC
        title="Print Request Settings"
        elAction={(
          <Button
            type="submit"
            disabled={loading}>
            Save
          </Button>
        )}>

        <Typography>
          This value is used to determine the label type when generating print requests in NetSuite for Tier1 RMAs.
        </Typography>

        <Stack spacing={1}>
          <Controller
            control={form.control}
            name="returnLabelType"
            render={({ field }) => (
              <Select
                size="small"
                fullWidth
                {...field}
                required
                disabled={loading}>
                <MenuItem value="rma-tmo">T-Mobile</MenuItem>
                <MenuItem value="rma-vzw">Verizon</MenuItem>
              </Select>
            )} />

          <ControlledTextField
            fieldKey="printRequestFunctionInternalId"
            label="Function Internal ID"
            {...fieldProps} />

          <ControlledTextField
            fieldKey="printRequestLabelInternalId"
            label="Label Internal ID"
            {...fieldProps} />

          <ControlledTextField
            fieldKey="printRequestPrinterInternalId"
            label="Printer Internal ID"
            {...fieldProps} />
        </Stack>
      </BaseWidget.FC>
    </Form.FC>
  );
};
